import classnames from "classnames";
import React, { Suspense } from "react";
import { StoreLocatorPrismic } from "src/components";
import styled from "styled-components";

import { Slice } from "../components";
import { ISliceStoreLocator } from "../types";

const StyledStoreLocatorPrismic = styled(StoreLocatorPrismic)`
  h3 {
    padding: 0;
  }
`;

export const StoreLocator = ({
  slice_type,
  primary,
  items,
}: ISliceStoreLocator): JSX.Element | null => {
  const { class_name: className, map_sku, map_data } = primary;

  if (!map_sku || !map_data) {
    return null;
  }

  return (
    <Slice
      className={classnames("slice-store-locator", className)}
      fullWidth="xxl"
      padding="0"
      noGutter
    >
      <Suspense fallback={<div />}>
        <StyledStoreLocatorPrismic data={{ ...primary }} />
      </Suspense>
    </Slice>
  );
};
